export const order = {
  orderHistorySearchForm: {
    label: {
      salesOrderNumber: 'Numéro de commande client',
      accountNumber: 'Numéro de compte',
      accountName: 'Nom du compte',
      purchaseOrderNumber: 'Bon de commande du client',
      orderType: 'Type de commande',
      creditStatus: 'Statut de crédit',
      deliveryBlock: 'Blocage de livraison',
      pastDue: 'En souffrance',
      productNumber: 'Numéro de catalogue',
      status: 'Statut de la commande',
      invoiceNumber: 'Numéro de facture',
      from: 'Du',
      to: 'Au',
      quickOrderLookup: 'Recherche rapide de commande',
      exportOrderHistory: 'Exporter l\'historique des commandes',
    },
  },
  orderHistoryResult: {
  header: {
      orderNumber: 'Numéro de commande',
      purchaseOrderNumber: 'Bon de commande du client',
      accountNumber: 'Numéro de compte',
      accountName: 'Nom du compte',
      status: 'Statut de la commande',
      createdDate: 'Date de création de la commande',
      orderValue: 'Total de la commande',
      creditStatus: 'Statut de crédit',
      deliveryBlock: 'Blocage de livraison',
      orderType: 'Type de commande',
      createdBy: 'Créé par',
      pastDue: 'En souffrance',
      customer: 'Nom du compte',
      shipToName: 'Nom du destinataire',
      lastShipDate: 'Date de dernière expédition',
    },
    widgetHeader: {
      orderNumber: 'N° de commande',
      purchaseOrderNumber: 'Bon de commande du client',
      createdDate: 'Date de création',
    },
    nodataMsg: 'Désolé! Aucune commande trouvée',
    showMore: 'Afficher plus',
    detailedSearch: 'Recherche détaillée',
  },
  knbrOrderDetails: {
    label: {
      srNo: 'Article de la commande',
      orderNumber: 'Numéro de commande',
      orderStatus: 'Statut de la commande',
      orderType: 'Type de commande',
      poNumber: 'Bon de commande du client',
      soldTo: 'Vendu à',
      shipTo: 'Expédier à',
      orderCreationDate: 'Date de création de la commande',
      orderPlacedBy: 'Commande passée par',
      jobNumber: 'Numéro de travail',
      shippingNotes: 'Notes de livraison',
      reqShipDate: 'Date d\'expédition demandée',
      shippingMethod: 'Mode de livraison',
      totalQty: 'Quantité totale',
      orderTotal: 'Total de la commande',
      downloadDocs: 'Documents',
      downloadPdf: 'Exporter les détails de la commande (PDF)',
      qty: 'Qté',
      atpDate: 'Date ATP',
      plant: 'Usine',
      lineItemStatus: 'Statut',
      quoteId: 'ID de soumission',
      openQuantity: 'Quantité ouverte',
      unitNetPrice: 'Prix net unitaire',
      shipments: 'Expéditions',
      orderQty: 'Qté commandée',
      shipDate: 'Date d\'expédition',
      shipQty: 'Qté expédiée',
      originalEstShipDate: 'Date d\'expédition estimée initiale',
      currentEstShipDate: 'Date d\'expédition estimée actuelle',
      lastShipDate: 'Date de dernière expédition',
      shipFromPackingList: 'Expédié de / Liste de colisage',
      totalLinePrice: 'Prix total du poste',
      status: 'Statut',
      deliveryNumber: 'Numéro de livraison',
      carrier: 'Transporteur',
      tracking: 'Suivi',
      trackingId: 'Suivi',
      shipFrom: 'Expédié de',
      packingList: 'Liste de colisage',
      delivery: 'Livraison',
      qtyShipped: 'Qté expédiée',
      shippingStatus: 'Statut d\'expédition',
      shippingType: 'Type d\'expédition',
      shippingCarrier: 'Nom du transporteur',
      carrierName: 'Nom du transporteur',
      freightTerms: 'Conditions de transport',
      contractor: 'Entrepreneur',
      collect: 'Perception',
    },
    actions: {
      reorderAction: 'Recommander',
      returnRMAAction: 'Retourner la commande (RMA)',
      returnZRREAction: 'Retour de commande REP (ZRRE)',
      cancelAction: 'Annuler la commande',
      editAction: 'Modifier la commande',
      saveEditOrder: 'Sauvegarder la commande modifiée',
      cancel: 'Annuler',
      backOrderHistory: 'Retour à l\'historique des commandes',
    },
    reOrderMessage: {
      success: 'La commande a été convertie en brouillon de commande avec succès.',
      error: 'Une erreur est survenue lors de la repassation de la commande.',
    },
    returnOrder: {
      navigationWarning: 'La commande ne peut pas être retournée pour le moment',
    },
    addProducts: {
      product: 'Produit',
      itemDetails: 'Détails de l\'article',
      listPrice: 'Prix de liste',
      qty: 'Qté',
      total: 'Total',
      minorderQty: 'Quantité minimale de commande',
      deliveryUnit: 'Unité de livraison ',
      productwarnmsg: 'Ce produit ne peut pas être acheté. Veuillez saisir un autre SKU',
      skuplaceholder: 'Saisir le SKU',
      lineNo: 'N° de ligne',
    },
    editOrder: {
      successMsg: 'Votre commande a été modifiée avec succès',
      confirmHeading: 'Votre numéro de commande est',
      processMessage: 'Votre commande est en cours de traitement pour les modifications demandées',
      errorMsg: 'Erreur lors de la modification de la commande',
      backButton: 'Retour à l\'historique des commandes',
      product: 'Produit',
      itemDetails: 'Détails de l\'article',
      listPrice: 'Prix de liste',
      qty: 'Qté',
      total: 'Total',
      cancelItem: 'Annuler le poste',
      qtyMsg: 'Vous pouvez seulement diminuer la quantité',
      addoreditwarnmsg: 'Veuillez ajouter ou modifier au moins un produit',
      cancelReasonMsg: 'Sélectionner le motif d\'annulation',
      cancelSelectWarning: 'Veuillez sélectionner un motif d\'annulation pour les articles annulés',
    },
  },
  knbrCancelOrder: {
    cancel: {
      success: 'Votre commande a été annulée avec succès.',
      error: 'Une erreur est survenue lors de l\'annulation de la commande.',
    },
    modalTitle: 'VOUS AVEZ DEMANDÉ L\'ANNULATION DE CETTE COMMANDE. SOUHAITEZ-VOUS CONTINUER?',
    modalMsg: 'Veuillez indiquer le motif de l\'annulation',
    yesBtn: 'OUI',
    noBtn: 'NON',
    confirmation: {
      heading: 'Votre commande a été annulée avec succès.',
      summary: 'ID d\'annulation : ',
    },
  },
  knBrOrderReturn: {
    create: {
      success: 'Votre retour a été créé avec succès.',
      error: 'Une erreur est survenue lors de la création de la commande de retour.',
    },
    button: {
      rma: 'Créer une commande de retour',
      zrre: 'Créer une commande de retour REP',
    },
    product: 'Produit',
    code: 'Code',
    description: 'Description',
    price: 'Prix net',
    qty: 'Qté',
    returnQty: 'Qté à retourner',
    returnwarningMsg: 'Des frais de restockage peuvent s\'appliquer au retour.',
    reason: 'Motif',
    orderNumber: 'Numéro de commande :',
    notes: 'Notes sur le motif',
    poNumber: 'Bon de commande du client :',
    createReturnorder: 'Créer un retour de commande',
    noteserrorMsg: 'Veuillez fournir une note indiquant le motif du retour.',
    confirmation: {
      returnrequest: 'Votre demande de retour a été reçue',
      returnnotes: 'Veuillez vous reconnecter au site après quelques instants pour consulter cette commande et ses détails',
      summary: 'Sommaire de la commande de retour',
      backbuttonlabel: 'Retour aux détails de la commande',
    },
  },
  orderReturnResult: {
    header: {
      rma: 'RMA',
      createdOn: 'Créé le',
      purchaseOrderNumber: 'Bon de commande du client',
      status: 'Statut',
      netValue: 'Valeur nette',
      accountName: 'Nom du compte',
      accountNumber: 'Numéro de compte',
      customer: 'Nom du compte',
      rdd: 'DDL',
    },
    widgetHeader: {
      purchaseOrderNumber: 'Bon de commande du client',
      orderValue: 'Valeur de la commande',
    },
    nodataMsg: 'Désolé! Aucune commande trouvée',
    showMore: 'Afficher plus',
    detailedSearch: 'Recherche détaillée',
  },
  orderReturnsSearchForm: {
    label: {
      rma: 'RMA',
      poNumber: 'Bon de commande du client',
      filterByStatus: 'Filtrer par statut',
      productNumber: 'Numéro de catalogue',
      accountNumber: 'Numéro de compte',
      accountName: 'Nom du compte',
      return: 'Retours',
      from: 'Du',
      to: 'Au',
    },
    placeholder: {
      rma: 'Saisir le numéro RMA',
      poNumber: 'Bon de commande du client',
      status: 'Statut',
      productNumber: 'Saisir le numéro de catalogue',
      accountNumber: 'Numéro de compte',
      accountName: 'Nom du compte',
    },
  },
  knbrReturnOrderDetails: {
    label: {
      returnCreateDate: 'Date de création du retour',
      returnNumber: 'Numéro de retour',
      soldTo: 'Vendu à',
      PO: 'B.C.',
      returnReason: 'Motif du retour',
      returnNote: 'Note de retour',
      totalReturnValue: 'Valeur totale du retour',
      overallStatus: 'Statut global',
      orderNumber: 'Numéro de commande',
      creditMemoNumber: 'Numéro de note de crédit',
      returnOrderConfirmation: 'Confirmation de commande de retour',
      credit: 'Crédit',
      customerOriginalPaperwork: 'Documents originaux du client',
      product: 'Produit',
      code: 'Code',
      description: 'Description',
      qty: 'Qté',
      itemNetPrice: 'Prix net de l\'article',
    },
    heading: {
      followUpDocuments: 'Documents de suivi',
      attachments: 'Pièces jointes',
    },
    actions: {
      backOrderReturns: 'Retour aux retours',
    },
  },
  freightPopUp: {
    heading: 'Conditions de transport',
    line1:
      'Votre commande est proche de l\'une de nos catégories de transport. Veuillez revoir votre commande afin de déterminer si du matériel supplémentaire doit être ajouté.',
    line2: '1. Les commandes d\'une valeur nette de 3 500 $ ou plus sont expédiées franco de port dans les États-Unis contigus.',
    line3: '2. Tout évier est expédié franco de port à partir de 15 000 $ net, peu importe le contenu de la commande.',
    line4:
      '3. Toute commande contenant uniquement de la faïence (appareil ou ensemble d\'appareil) est expédiée franco de port à partir de 10 000 $ net.',
    line5: 'Cliquez sur Retour au panier pour ajouter à votre commande ou sur Passer la commande pour soumettre votre commande.',
    backToCartBtn: 'Retour au panier',
    checkOutBtn: 'Passer la commande',
  },
};
